import React from 'react';
import PropTypes from 'prop-types';
import styles from './table.module.scss';
import TableSkeleton from '../Skeletons/TableSkeleton';

function Table({ cols, data, pendingFetch }) {
  return (
    <table className={`table text-center ${styles.table}`}>
      <thead>
        <tr>
          {cols.map((headerItem) => (
            <th key={headerItem}>{headerItem.title}</th>
          ))}
        </tr>
      </thead>
      {pendingFetch ? (
        <tbody data-testid="body">
          {Array.from({ length: 5 }, (v, k) => k).map((_, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableSkeleton key={idx} qty={6} />
          ))}
        </tbody>
      ) : (
        <tbody data-testid="body">
          {data?.map((item) => (
            <tr key={item}>
              {cols?.map((col) => (
                <td key={col}>{col.render(item)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      )}
    </table>
  );
}

Table.propTypes = {
  cols: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  pendingFetch: PropTypes.bool.isRequired
};

export default Table;
